import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import PopOver from '../../../Shared/Popover/Popover';
import PopUp from '../../../Shared/Popup/PopUp';
import { isMobile } from 'react-device-detect';
import { reportAnalytics } from '../saleBlockSlice';
import mobileIconFooter from './images/mobile-icon-footer.svg';
import closeFooterPopup from './images/close-footer-popup.svg';

const SaleFooter = (props) => {

  const [toolTip, setToolTip] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [priceToDisplay, setPriceToDisplay] = useState(props.price);
  const [isAnimationEndMobile, setIsAnimationEndMobile] = useState(false);

  const totalProducts = props.selectedProducts?.length;

  useEffect(() => {
    if (props.selectedProducts?.length == 2) {
      if (isAnimationEndMobile) {
        if (props.isNewNumberPageAnimationEnd) {
          setToolTip(true);
        }
      }
      if (props.isNewNumberPageAnimationEnd) {
        setToolTip(true);
      }
    }
  }, [props.isNewNumberPageAnimationEnd, isAnimationEndMobile]);

  useEffect(() => {
    if (props.price && props.price.toString().indexOf('.') != -1) {
      setPriceToDisplay(props.price.toFixed(2));
    } else if (props.price) {
      setPriceToDisplay(props.price);
    }
  }, [props.price]);

  if (!props.isDisplayFooter) {
    return null;
  }

  const closeTooltip = (e) => {
    e.stopPropagation();
    setToolTip(false);
  };

  const openPopUp = () => {
    if (props.selectedProducts?.length > 0) {
      setToolTip(false);
      setShowPopUp(true);
      props.reportAnalytics({
        eventCategory: 'cellular_newsale_process',
        eventAction: props.flowType == 'existsCustomer' ? 'visibility_8' : 'visibility_19',
        eventLabel: props.selectedProducts[0]?.name,
      });
    }
  };

  const closePopUp = () => {
    setShowPopUp(false);
    props.reportAnalytics({
      eventCategory: 'cellular_newsale_process',
      eventAction: props.flowType == 'existsCustomer' ? 'click_19' : 'click_40',
      eventLabel: props.selectedProducts[0]?.name,
    });
  };

  return (
    <>
      <footer className={`sale-footer clearfix ${props.isEsimFooter ? 'footer-center-div' : ''}`} >
        <div className={`sale-footer-wrapper ${isMobile ? 'slideAnimation' : ''} ${props.isEsimFooter && !isMobile ? 'sale-footer-wrapper-width' : ''}`} onAnimationEnd={() => setIsAnimationEndMobile(true)}>
          {props.price ? (
            <>
              {totalProducts && totalProducts > 0 && (
                <>
                  <div className='mobile-icon-wrapper' >
                    <div className='mobile-icon' id='device_count' aria-label='products count' style={{backgroundImage:mobileIconFooter.bg()}} onClick={() => openPopUp()}>
                      {totalProducts}
                    </div>
                    <PopOver
                      className='mobile-icon-popover'
                      placement='top'
                      text='בכל שלב, אפשר להקליק ולראות פה את פירוט ההזמנה'
                      target='device_count'
                      isOpen={toolTip}
                      closePopover={(e) => closeTooltip(e)}
                    />
                  </div>
                </>
              )}


              <div className={`price-wrapper ${props.isEsimFooter ? "center-price-div" : ""} `}>
                <div className='price-and-text clearfix'>
                  <div className='price'> <span style={{ fontSize: "18px" }}>₪</span>{priceToDisplay} </div>
                  <div className='price-text'> {props.priceText} </div>
                </div>
                {props.totalPriceOneTime > 0 && <div className='price-sub-text'> + חיוב חד פעמי {props.totalPriceOneTime} ₪ </div>}
              </div>
            </>
          ) : null}
          <div className={`${props.price && !props.isEsimFooter ? 'btn-left' : 'btn-center'} ${props.disableButton ? 'disableFooterButton' : ''}`}>
            <BtnSubmit
              isBusiness={false}
              text={props.btnText}
              onclick={props.onclick}
              formid={props.formid}
              isDisplayArrows={props.isDisplayArrows}
            />
          </div>
        </div>
      </footer>

      {
        props.selectedProducts && props.selectedProducts.length > 0 && (
          <PopUp showPopUp={showPopUp} onClose={() => closePopUp()} className='all-products-popup'>
            <h2>מה היה לנו?</h2>
            <p>סיכום הזמנתך עד כה</p>
            {props.selectedProducts.map(function (product, index) {
              const selectedPhone = product.isExistPhone ? product.existPhone : product.newPhone;

              const phone = selectedPhone ? selectedPhone.slice(0, 3) + '-' + selectedPhone.slice(3, selectedPhone.length) : '';
              return (
                <div className='products-wrapper' key={index}>
                  <div className='phone-wrapper'>
                    <div className='phone'>
                      קו {index + 1} - {phone}
                    </div>
                    <div className='btn'>
                      <button className='delete-product test' onClick={() => props.removeProduct(index)} style={{backgroundImage:closeFooterPopup.bg()}}></button>
                    </div>
                  </div>
                  <div className='product-name'>
                    <div className='text'>{product.name}</div>
                    <div className='price'>{product.additionalPrice} ₪ </div>
                  </div>
                  {product.selectedVasList?.map(function (vas, i) {
                    return (
                      <div className='product-name'>
                        <div className='text'>{vas.title}</div>
                        <div className='price'>{vas.price == '' || vas.price == '0' ? 'כלול בחבילה' : vas.price + ' ₪'} </div>
                      </div>
                    );
                  })}
                  <div className='product-name'>
                    <div className='text'>{product.isEsim ? 'eSim דיגיטלי בעלות חד פעמית' : 'כרטיס SIM בעלות חד פעמית'}</div>
                    <div className='price'>{product.oneTimeFee} ₪ </div>
                  </div>
                  {product.isPrettyNum && (
                    <div className='product-name'>
                      <div className='text'>{product.prettyNumberName}</div>
                      <div className='price'>
                        {product.prettyNumberPrice == '' || product.prettyNumberPrice == '0' ? (
                          'ללא עלות'
                        ) : (
                          <>{product.prettyNumberPrice} ₪</>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            <div className='footer-popup'>
              <div className='total-price'>
                <span className='text'>סה"כ חיוב חודשי</span>
                <span className='price'>{props.price} ₪ </span>
              </div>
              <div className='total-price'>
                <span className='text'>סה"כ עלות חד פעמית</span>
                <span className='price'>{props.totalPriceOneTime} ₪ </span>
              </div>
            </div>
          </PopUp>
        )
      }
    </>
  );
};

const mapStateToProps = (state) => {
  return { flowType: state.saleBlock.flowType };
};

const mapDispatchToProps = {
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(SaleFooter);
